module.exports = __webpack_public_path__ + "static/media/privacyPolicyGreen.460aa1e4.svg";